import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { styled } from '@mui/material/styles';
const BlurryDialog = styled(Dialog)(({ theme }) => ({
    backdropFilter: 'blur(2px)',
}));
const ConfirmDialog = (props) => {
    const { title, children, open, setOpen, onConfirm, confirmText, cancelText } = props;
    return (_jsxs(BlurryDialog, { transitionDuration: 0, hideBackdrop: true, open: open, onClose: () => setOpen(false), "aria-labelledby": "confirm-dialog", children: [_jsx(DialogTitle, { id: "confirm-dialog", children: title }), _jsx(DialogContent, { children: children }), _jsxs(DialogActions, { children: [_jsx(Button, { variant: "outlined", onClick: () => setOpen(false), color: "inherit", children: cancelText }), _jsx(Button, { variant: "contained", onClick: () => {
                            setOpen(false);
                            onConfirm();
                        }, color: "error", children: confirmText })] })] }));
};
export default ConfirmDialog;
